import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "historyFormatter",
  standalone: true,
  pure: true,
})
export class HistoryFormatterPipe implements PipeTransform {
  transform(value: any, transformation: string): string {
    const t = transformation.toLowerCase();
    if (t.includes("date")) {
      return new Date(value).toLocaleString();
    } else if (t.includes("status")) {
      switch (value) {
        case 0:
          return "Not Started";
        case 1:
          return "In Progress";
        case 2:
          return "On Hold";
        case 3:
          return "Completed";
      }
    } else if (t.includes("completed")) {
      return value ? "Completed" : "Not Completed";
    } else if (t.includes("urgent") || t.includes("recurring")) {
      return value ? "Yes" : "No";
    }
    return value;
  }
}
